<template>
  <div class="ecm__body">
    <div class="ecm__body-top_books section__padding" v-if="bestSeller.length !== 0">
      <h1 class="ecm__body-top_books-title ecm__body-title">
        Our Books
      </h1>
      <Books v-if="!activeSkeleton" :books="bestSeller" />
      <p>
        <button @click="$router.push('/books')">See all our books</button>
      </p>
    </div>
    <div class="ecm__body-choose-us section__padding">
      <h1 class="ecm__body-choose-us__title ecm__body-title">
        Why Should Choose us?
      </h1>
      <div class="ecm__body-choose-us__contents-superiority">
        <div
          v-for="(item) in optionsChoose" :key="item.id"
          class="ecm__body-choose-us__contents-superiority__item"
        >
          <div class="ecm__body-choose-us__contents-superiority__item-icon">
            <i :class="item.icon"></i>
          </div>
          <p class="ecm__body-choose-us__contents-superiority__item-title">{{ item.title }}</p>
          <p class="ecm__body-choose-us__contents-superiority__item-description">
            {{ item.desc }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Books from '@/components/Books.vue'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Body_Home_Component',
  components: {
    Books
  },
  data () {
    return {
      activeSkeleton: true,
      currentDate: '2021-06-01',
      optionsChoose: [
        {
          id: 1,
          title: 'Safe Shipping',
          icon: 'fas fa-shipping-fast',
          desc: 'We have collaborated with some of the best shipping services in Indonesia. Like J&T, etc'
        },
        {
          id: 2,
          title: 'Easy Payments',
          icon: 'fas fa-shopping-basket',
          desc: 'There are several choices of payment methods that can make payments easier'
        },
        {
          id: 3,
          title: 'Many Kinds of Books',
          icon: 'fas fa-book',
          desc: 'You can get all kinds of books here'
        }
      ]
    }
  },
  mounted () {
    this.$root.$on('fetchBestSeller', () => {
      this.handleGetBestSeller()
    })
    this.handleGetBestSeller()
  },
  computed: {
    ...mapState({
      bestSeller: state => state.book.bestSeller
    })
  },
  methods: {
    ...mapActions({
      getBestSeller: 'book/fetchBestSeller'
    }),
    async handleGetBestSeller () {
      try {
        const data = await this.getBestSeller({ limit: 8, userId: localStorage.getItem('userId') })
        if (data.status === 'success') {
          setTimeout(() => {
            this.$data.activeSkeleton = false
          }, 1000)
        }
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__body {
  .ecm__body-title {
      text-align: center;
      margin-bottom: 20px;
      font-weight: 600;
      text-transform: uppercase;
      cursor: default;
      font-size: 25px;
  }
  .ecm__body-top_books {
    .ecm__body-top_books-title {
      color: var(--color-blue-background);
    }
    p {
      text-align: right;
      button {
        padding: 5px 15px;
        border: none;
        outline: none;
        background: var(--color-yellow);
        color: var(--color-blue-background);
        font-weight: 500;
        border-radius: 22px;
        cursor: pointer;
      }
    }
  }
  .ecm__body-choose-us {
    .ecm__body-choose-us__title {
      color: var(--color-blue-background);
    }
    .ecm__body-choose-us__contents-superiority {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      .ecm__body-choose-us__contents-superiority__item {
        width: 320px;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 10px;
        border-radius: 3px;
        .ecm__body-choose-us__contents-superiority__item-icon {
          display: flex;
          justify-content: center !important;
          align-items: center;
          width: 35px;
          height: 35px;
          background: var(--color-blue);
          border-radius: 50%;
          transition: .3s;
          i {
            font-size: 15px;
            color: white;
            transition: .3s;
          }
        }
        .ecm__body-choose-us__contents-superiority__item-title {
          font-weight: 500;
          font-size: 14px;
          margin: 10px 0;
        }
        .ecm__body-choose-us__contents-superiority__item-description {
          font-size: 14px;
          text-align: center;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__body {
    .ecm__body-fyi {
      .ecm__body-fyi_book-image {
        height: 350px !important;
      }
      .ecm__body-fyi_book-description {
        p {
          font-size: 13px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .ecm__body {
    .ecm__body-title {
      font-size: 25px;
    }
    .ecm__body-choose-us {
      .ecm__body-choose-us__contents-superiority {
        .ecm__body-choose-us__contents-superiority__item {
          width: 200px;
          .ecm__body-choose-us__contents-superiority__item-description {
            font-size: 11px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__body {
    .ecm__body-title {
      font-size: 25px;
    }
    .ecm__body-top_books {
      .ecm__body-top_books-items {
        display: none;
      }
      .carousel-card {
        display: block;
        &::v-deep .owl-item {
          padding: 5px;
        }
      }
    }
    .ecm__body-choose-us {
      .ecm__body-choose-us__contents-superiority {
        flex-direction: column;
        .ecm__body-choose-us__contents-superiority__item {
          width: 100%;
          justify-content: center;
          height: 150px;
        }
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .ecm__body {
    .ecm__body-title {
      font-size: 15px;
    }
    .ecm__body-top_books {
      .ecm__body-top_books-items {
        display: none;
      }
    }
  }
}
</style>
